import { Injectable } from '@angular/core';
import { EMPTY, Observable, catchError, throwError } from 'rxjs';
import { AgencyOfficerDetailsRequest, OfficerPersmissionsRequest } from '../models/officer-details-request.models';
import { AgencyOfficerDetailsResponse, OfficerPermissionsResponse } from '../models/officer-details-response.models';
import { BaseApiService } from '@shared/data-access';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AgencyOfficerDetailsService {
  constructor(private api: BaseApiService, private router: Router) {}

  fetchAgencyOfficerDetails(uid: string): Observable<AgencyOfficerDetailsResponse> {
    return this.api.get<AgencyOfficerDetailsResponse>(`api/users/${uid}`).pipe(
      catchError((error) => {
        if (error.status === 403) {
          this.router.navigate(['Error', '403']);

          return EMPTY;
        }

        return throwError(() => error);
      })
    );
  }

  fetchAgencyOfficerPermissions(uid: string): Observable<OfficerPermissionsResponse> {
    return this.api.get<OfficerPermissionsResponse>(`api/users/${uid}/permissions`);
  }

  updateAgencyOfficerDetails(uid: string, agencyOfficerDetails: AgencyOfficerDetailsRequest): Observable<AgencyOfficerDetailsResponse> {
    return this.api.put(`api/users/${uid}`, agencyOfficerDetails);
  }

  updateAgencyOfficerPermissions(uid: string, agencyOfficerPermissions: OfficerPersmissionsRequest): Observable<AgencyOfficerDetailsResponse> {
    return this.api.patch(`api/users/${uid}/permissions`, agencyOfficerPermissions);
  }
}
